import React from 'react';

import { GENDER_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxCustomFilter } from '../components/checkbox-custom-filter/CheckboxCustomFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const GenderCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const selectedGender = useWatch({ name: 'gender' });
  const filterCount = selectedGender ? 1 : 0;
  useFilterCount('gender', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="genderFilter"
      triggerValue={t('gender')}
      {...props}
    >
      <CheckboxCustomFilter
        control={control}
        name="gender"
        options={GENDER_OPTIONS.raw}
      />
    </CustomFilterPopover>
  );
};
